import React, { useEffect } from "react"

const useIsMobile = (breakpoint = 820) => {
  const [isMobile, setIsMobile] = React.useState(false)

  useEffect(() => {
    if (typeof window === "undefined") return

    const check = () => {
      setIsMobile(window.innerWidth <= breakpoint)
    }

    check()
    window.addEventListener("resize", check)
    return () => window.removeEventListener("resize", check)
  }, [breakpoint])

  return isMobile
}

export default useIsMobile
